<template>
  <div>
  <el-form
    :model="listForm"
    ref="listForm"
    :rules="releaseRules"
    class="editForm"
    label-width="148px"
  >
    <el-row>
        <el-col :span="12">
        <el-form-item label="申报状态:" prop="taxReportStatus">
          <el-input v-model="listForm.taxReportStatus" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  </div>
</template>

<script>

  import {getTaxList,getTaxBatchById,updateTaxBatch,getBatchEmpByIdList,getEmpDetailByIdList} from "@/api/tax/tax";
  import {mapGetters} from 'vuex';
   export default {
        name: "editTaxStatus",
      props: {
        listForm: {
          type: Object,
          default: () => ({})
        },
        dialogFormVisible: {
          type: Boolean,
          default: false
        },
        dialogStatus: {
          type: String,
          default: ""
        }
      },
        watch: {
          listForm: {
            handler(newVal, oldVal) {
              // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
              this.$emit("update:listForm", newVal);
            },
            immediate: true,
            deep: true
          }
        },
        created() {

        },
        mounted() {

        },
        computed: {
          ...mapGetters([
            'memberInfo',
          ]),
        },
        data(){
          return{
         releaseRules: {
               taxReportStatus: [{required: true, message: "申报状态不能为空", trigger: "blur"}],
            }
          }
        },
        methods:{


        }



    }
</script>

<style scoped>

</style>
